export default {
  PriceUnit: 'HK$',
	IndexNavbar: {
		HomePage: "首頁",
		Founder: "創始人",
		Artwork: "藝術品",
		Pieces: "件",
		Artists: "藝術家",
		PrivateArtSteward: "私人藝術管家",
		BusinessModelCase: "商業模式",
		Photo: "活動相册",
		LatestNews: "最新消息",
		AboutUs: "關於我們",
		RecommendArtwork: "推薦藝術品",
		RecommendArtists: "推薦藝術家",
		JumpLink: "相關視頻",
		NewsDetail: '消息詳情'
	},
	IndexAboutUs: {
		AboutUs: "關於我們",
		Introduce: "經藝聯傾力打造的當代原創藝術品電商交易服務平臺。 旨在推動藝術品消費大眾化，依託於專業團隊，在全國範圍內持續挖掘優秀藝術品，將大量經過嚴格篩選的高品質原創藝術品通過線上藝術品電商平臺帶給大眾，形成一整套專業、可信賴的藝術消費服務",
		Address: "地址: 香港銅鑼灣希慎道8號裕景商業中心2樓97室",
		Tel: "電郵: info@kingsarts.com"
	},
	FooterNavbar: {
		Artwork: "藝術品",
		Artists: "藝術家",
		PromoteSales: "推廣銷售",
		PromoteManager: "推廣經理",
		SecondSale: "二次銷售",
		SalesCase: "銷售案例",
		SiteName: "經藝聯",
		AboutUs: "關於我們"
	},
	Founder: {
		SendWord: "黃博士寄語",
		SendWordMsg1: "活在藝術多姿多彩 相反 枯燥無味",
		SendWordMsg2: "活在藝術吃盡八方 相反 力竭聲嘶",
		Founder: "黃經國博士",
    TakeOffice1: "冠軍專業管理有限公司",
    TakeOffice2: "Asia Trusted Life Agents & Advisors Award 2021",
    TakeOffice3: "經藝控股有限公司",
    TakeOffice4: "經藝（深圳）藝術品電子商務有限公司",
    TakeOffice5: "“喂我” 實現工程有限公司",
    TakeOffice6: "香港中文大學新亞書院",
    TakeOffice7: "香港理工大學基金",
    TakeOffice8: "清華大學美術學院-清華大學經濟管理學院-蘇富比藝術學院",
    TakeOffice9: "香港理工大學總裁協會",
    TakeOffice10: "中國古董藝術總會",
    TakeOffice11: "香港亞洲獅子會",
    TakeOffice12: "香港銀行學會",
    TakeOffice13: "鏡報",
    TakeOffice14: "2007-2015年香港學術評審局",
    TakeOffice15: "2007-2008年持續兩屆榮獲CEO資本才俊",
    Position1: "主席",
    Position2: "終身成就獎",
    Position3: "主席",
    Position4: "主席",
    Position5: "主席",
    Position6: "校董",
    Position7: "永遠榮譽副會長",
    Position8: "藝術管理碩士",
    Position9: "副理事長",
    Position10: "主席",
    Position11: "前任會長",
    Position12: "專業財富管理師",
    Position13: "顧問",
    Position14: "委任行業/學科專家",
    Position15: "非凡品牌大獎",
		Story1: "黃博士「冠軍專業管理有限公司」主席，擁有超過3,500名財務策劃顧問「冠軍家族團隊」，當中包括24位資深區域總監及區域總監。工餘時間在美國不斷進修，獲取眾多科目不同資格，為人才資本培訓專家、從事企業輔導、領袖培訓、營銷推廣、保險及財務顧問管理工作數十年，為行業的翹楚。近年也獲得保險行業終身成就獎。黃博士亦是香港中文大學《新亞書院》校董、《香港理工大學基金》永遠榮譽副會長、《香港理工大學總裁協會》副理事長及《世界傑出華人會》創會主席。興趣方面也累積古董數十年收藏經驗， 近70歲也考取《清華大學》美術學院-《清華大學》經濟管理學院-《蘇富比》藝術學院-藝術管理碩士資格。",
		Story2: "與全國政協副主席梁振英先生合照",
		Story3: "榮獲2015年APEA亞太企業家獎",
		Story4: "黃經國博士與香港特別行政區行政長官林鄭月娥女士合照",
		Story5: "2017年《鏡報》顧問第六屆傑出企業社會責任獎中致詞",
		Story6: "與樹仁大學校監胡鴻烈大律師合照",
		Story7: "2004年接受「美國總統優質教育獎」並在典禮中致詞",
		Story8: "黃博士于2019年3月畢業《清華大學》美術學院-《清華大學》經濟管理學院-《蘇富比》藝術學院-藝術管理碩士",
		Story9: "與澳門特首崔世安先生合照士",
		Story10: "于《鏡報》第六屆傑出企業社會責任獎頒獎典禮與梁振英先生擔任頒獎嘉賓",
		Story11: "與前政務司司長唐英年合照",
	},
	PrivateArtSteward: {
		ArtSteward: "經藝聯私人藝術管家",
		Content1: "",
		Content2: "職責及工作指引",
		Content3: "1. 代理四個商家或藝術家，充分了解每件藝術作品的創作理念及內涵價值。 ",
		Content4: "2. 線下協助藝術愛好者或收藏家了解所代理的藝術家的作品。",
		Content5: "3. 溝通和協調藝術愛好者在購買過程中的各種疑問",
		Content6: "4. 進行細緻嚴謹的交收跟進。",
		Content7: "5. 與各藝術大咖深入交流的機會。",
		Content8: "6. 個人的社交圈將得到更深入的擴展。",
		Content9: "7. 持續進修藝術培訓及市場策略導師的指導，個人創造力最大程度彰顯。",
		Content10: "8. 世界各地遊學及藝術深造的機會。",
		Content11: "",
		Content12: "",
		Content13: "",
		Content14: "",
	},
	BusinessModel: {
		Amateur: "藝術藏家",
		AmateurUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business1.png",
		Artists: "藝術家",
		ArtistsUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business2.png",
		ArtSpecialist: "藝術總監",
		ArtSpecialistUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business3.png",
		PrivateArtSteward: "私人藝術行政管家",
		PrivateArtStewardUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business4.png",
		ArtPromotionManager: "私人藝術管家",
		ArtPromotionManagerUrl: "https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/business5.png",
		ModelCase: "商業模式案例"
	},
	AboutUs: {
		Clauses: "經藝聯 使命",
		Clauses1: "為藝術家和藏家架起溝通的橋樑",
		Clauses2: "發掘和推廣中國當代藝術",
		Clauses3: "讓藝術融入每個人的日常生活",
		Clauses4: "",
		SharedValues: "經藝聯 價值觀",
		Challenge : "",
		Activitier: "",
		Acknowledgement: "",
		Aesthetic: "",
		Value: "經藝聯 私人藝術管家",
		CompanyProfile: "公司簡介",
		CompanyProfile1: "「經藝聯」是一家以香港為總部 ，國內為基地，全球為市場的私人藝術管家推廣集團。" ,
		CompanyProfile2: "我們有獨特的鐵三角推廣引擎，以智能、道德、意志為原動力，發展推廣當代藝術品，以新的市場策略、人才資本及強而有力的執行力，旨在改變現有的藝術生態圈，為藝術家提供一個更寬廣、更透明、多維度的藝術銷售平台，將中國的當代藝術弘揚世界。",
		CompanyProfile3: "",
		CompanyProfile4: "",
		CompanyProfile5: "",
		CompanyProfile6: "",
		Management: "管理團隊",
		Name: "黃經國博士",
		position: "創始人 - 總裁",
		Resume: "「經藝聯」始創人、「香港中西藝術及文化交流協會有限公司」主席、「大灣區香港藝術品交易中心有限公司」主席、「經藝管家學院」院長、「冠軍專業管理有限公司」主席、《求知雅集》古董學會會長、香港中文大學《新亞書院》校董、《香港理工大學基金》永遠榮譽副會長、《香港理工大學總裁協會》副理事長 及《世界傑出華人會》創會主席。興趣方面也累積古董數十年收藏經驗， 近70歲也考取《清華大學》美術學院-《清華大學》經濟管理學院-《蘇富比》藝術學院-藝術管理碩士資格。黃博士亦是《友邦保險》區域執行總監及榮譽顧問，擁有超過 4,500名 財務策劃顧問「冠軍家族團隊」，當中包括 43位 資深區域總監及區域總監。工餘時在美國不斷進修，獲取眾多科目不同資格，為人才資本培訓專家、從事企業輔導、領袖培訓、營銷推廣、保險及財務顧問管理工作數十年，也獲得保險行業終身成就獎，為行業翹楚。",
		Name1: "梁嘉欣女士",
		position1: "市場推廣總裁",
		Resume1: "梁小姐擁有超過10年的國際企業管理經驗，於自動化優化營運效率方面有豐富經驗。梁小姐負責經藝聯的市場推廣業務，以數字營銷和線上課程讓海外藝術愛好者了解中國當代藝術，以藝術打破地域界限、聯繫全球觀眾，發揮藝術於國際市場的獨有魅力！",
		Name2: "張翼雄律師",
		position2: "執行董事兼法律總監",
		Resume2: "藝術品收藏愛好者，現任香港執業律師（1995至今）、凱基證卷亞洲有限公司助理副總裁（2011至今）、香港上市公司匯能集團〔01539.HK〕獨立非執行董事（2015至今）及香港友邦保險財富管理經理（2015年至今），曾擔任香港中西區區議會區議員（2008至2015）。張律師認為藝術品除了能陶冶觀賞者的性情外，還見證了古今藝術家的努力成果，並通過交易及流通把當時當刻藝術文化收集、保存及傳承。他希望各藝術持份者及愛好者能通過「經藝聯」此平台多認識藝術、交流藝術、保存藝術，促進藝術文化發展與傳承！！",
		Name3: "鍾凱諺",
		position3: "藝術總監",
		Resume3: "曾就職于香港本土畫廊，多年藝術市場經驗，曾策劃多場展覽及主持分享活動，幫助拉近藝術與大衆之間的距離，爲藝術家職業生涯搭建基石。",
		Name4: "黃司政博士",
		position4: "執行董事兼行政總裁",
		Resume4: "黃司政先生，當代藝術品收藏愛好者，現任友邦保險（國際）有限公司區域總監、「經藝聯」執行董事及行政總裁、经艺控股有限公司執行董事、香港中西藝術及文化交流協會有限公司執行董事。黃先生對中國當代藝術品情有獨鍾，當中對水墨畫尤感興趣，希望通過不同渠道接觸更多藝術愛好者、藝術收藏家、年青新晉藝術家等等，籍此利用「經藝聯」平台作互相交流、認識及發掘更多別具風格和存有歷史價值的收藏品，促進香港藝術的長遠發展！",
		Name5: "王京京女士",
		position5: "主理人及合夥人",
		Resume5: "王女士擁有超過10年的當代藝術品收藏、交易和推廣經驗。她負責經藝聯的戰略發展和日常運營，依託香港作為國際化的平台，推動中國當代藝術與國際市場的融合，為中國當代藝術家和藝術作品在國際舞台上展示中國魅力提供服務和幫助。“希望經藝聯作为中國藝術家通往全球藝術市場的開放平台。”",
		Name6: "羅健昌",
		position6: "市場拓展總監",
		Resume6: "畢業於加拿大西安大略省大學電腦系，為資深網絡科技專家。他曾帶領名下一家公司在 Microsoft 勇奪一項全年大獎。他成功引入澳洲和美國上市公司及新加坡風險基金等策略性投資者，促成多次企業收購合併活動。他的投資包括美國上市企業、區塊鏈生態圈和數碼資產管理平台等。除科​​技外，他亦是著名商業心理教練，負責團隊的銷售培訓。他被譽為企業老闆、團隊和富二代的心鏡。",
		Name7: "鍾凱諺",
		position7: "藝術執行總監",
		Resume7: "藝術創作屬於個人情感和哲思的表達，藝術家在創作時投入的真誠情感更是無價的，然而我們還是需要一一地為他們標上數目字，才能量度它的價值。經藝聯以此基礎做推廣，相信這個平台，定能為社會大眾培養出更多出色的藝術家。",
		Marketplace: "我們的藝術市場",

    aboutUrl1: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_1.jpg',
    aboutUrl2: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_2.jpg',
    aboutUrl3: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_3.jpg',
    aboutUrl4: 'https://jingyiwang.oss-cn-hongkong.aliyuncs.com/static/about_4.jpg',
    
	},
	// 漏掉的翻译
	LastTranslate: {
		Name1: "經藝聯",
		Name2: "當代革新藝術交易平台",
		title1: '如何成為“私人藝術管家”',
		title2: '如何註冊',
		title3: "加入我們",
		title4: "Join Us",
		Address: "如果您對我們的課程感興趣，可聯繫我們，獲取更多資訊。",
    Tel: "電郵: info@kingsarts.com",
		All: "全部",
		AllLabel1: "綜合排序",
		AllLabel2: "時間排序",
		ScreenMenu: "篩選",
		ScreenTitle1: "傑出藝術品",
		ScreenTitle2: "價格",
		ScreenTitle3: "尺寸",
		ScreenTitle4: "主色調",
		ScreenTitle5: "形狀",
		ScreenTitle6: "擺放空間",
		Attribute: "屬性",
		AttributeName: "作品名稱",
		AttributeAtr: "藝術家",
		AttributeDate: "創作時間",
		AttributeMaterial: "材質",
		AttributeSize: "尺寸",
		WorksDetails: "作品詳情",
		RecommendedWorks: "推薦作品",
		ExpertsEvaluation: "專家評价",
		ArtInfo: "藝術家信息",
		ArtWorks: "藝術家作品",
		ArtIntroduced: "藝術家介紹",
		ArtCV: "藝術家履歷",
		ArtCV1: "個展",
		ArtCV2: "群展",
		ArtCV3: "館展",
		ArtCV4: "獲獎",
		Challenge: "挑戰自我",
		Activitier: "活動韻律",
		Acknowledgement: "修身養性",
		Aesthetic: "返璞歸真",
		ICP: "保留所有權利",
		ICP1: "粵ICP備20032099號",

	

		PayOur: '關注我們',
		ContactPhone: '聯絡電話',
		CustomerService: '客戶服務',
		ContactUs: '聯絡我們',
		LegalNotices: '法律聲明',
		generalLaw: '一般條款',
		butlerManagement: '專屬管家管理系統',
		SellerManagement: '賣家管理系統',
		Who: '我們是誰？',
		AboutUs: '關於我們',
		OurArtist: '我們的藝術家',
		OurTeam: '我們的團隊',
		QA: '常見問題',
		Contact: '聯絡方式',
		FOOfTitle1: '妳是藝術家/畫廊/收藏家嗎？',
		FOOfTitle2: '如何加入成為私人藝術管家？',
		ScanCodeTips1: '掃碼下載經藝聯賣家APP',
		ScanCodeTips2: '加入KingsArts',
		ScanCodeTips3: '掃碼下載經藝聯APP',
		ScanCodeTips4: '成為私人藝術管家',
		
		SittingRoom: "客廳",
		Bedroom: "睡房",
		Outdoor: "室外",
		PublicHall: '公共大廳',
		NoMore: '沒有更多推薦',
		registrationAgreement: '註冊協議與隱私政策',
		Download: 'APP下載',


		website: '官網',

		Below: '3000 以下',
		Above50000: '50000 以上',
		Above200: '200 以上'
	},
	ArtworkDetail: {
		Excellent: "傑出藝術品",
		Code: "編碼",
		PriceTips: "包括運費",
		References: "規格參數",
		ProductNumber: "組件編號",
		ArtworkName: "作品名稱",
		ArtworkType: "作品類型",
		Artists: "藝術家",
		CreateTime: "創作時間",
		Material: "材質",
		Size: "尺寸",
		ThemeColor: "主色調",
		Hue: "主色調",
		Red: "紅色",
		Green: '綠色',
		Blue: '藍色',
		Yellow: "黄色",
		Other: "其它",
		Gray: '灰色',
		Square: '正方形',
		Rectangle1: '長方形（橫）',
		Rectangle2: '長方形（直）',
		Roundness: '圓形',
		OtherShapes: '其他形狀',

		Shape: "形狀",
		Price: "價格",
		Seller: "賣家",
		TransactionHistory: "交易記錄",
		Time1: "第",
		Time2: "次",
		ArtworkDetails: "作品詳情",
		Comments: "留言",
		ArtworkInformation: "藝術品信息",
		ArtCritics: "藝術評價",
		Details: "圖文詳情",
		ArtistProfile1: "藝術家簡介",
		ArtistProfile2: "藝術家介紹",
		SoloExhibitions: "個展",
		GroupExhibitions: "群展",
		PavilionExhibitions: "館展",
		Awards: "獲獎",
		SeeAll: "查看全部",
		TakeBack: "收回",
		MoreData: "没有更多數據",
		Recommendations: "推薦商品",
		ArtistWorks: "藝術家作品",
		sold: "已售出",
		
		withdrawn: "已下架",
		Next: "下一頁",
		Previous: "上一頁",
		Home: "首頁",
		ArtworkName: "作品名稱",
		Material: "材質",
		CreateTime: "創作時間",
		download: "下載APP購買",
		viewArt: "查看藝術家主頁＞",
		how :"共",
		artworks: "件藝術品",
		works: "作品",
		Pieces: "件",
		EnterName: "輸入作品名稱",
		EnterArtName: "輸入藝術家名稱",
		Unlimited: "不限",
		select: "請選擇",
		ALL: "全部",
		DefaultSort: "綜合排序",
		TimeSort: "時間排序",
		Sort:"篩選",
		Reset: "重置",
		Confirm: "確定",
		ArtistInfo: "藝術家信息",
		ArtistResume: "藝術家履歷",
		NoMore: "— 完 —",
		Loading: "加載中",
		Refresh: "刷新成功",
		PullingText: "下拉即可刷新",
		LoosingText: "釋放即可刷新",
		Message: "董事長寄語",
		What: "什麼是“二次交易”",
		How: "如何成為“私人藝術管家”"
	},
	// 邀请注册
	Register: {
		Title: "邀請您加入經藝聯",
		NameBar1: "藝術管家",
		Reg: "立即註冊",
		MobilePla: "請輸入手機號碼",
		nickNamePla: "請輸入您的名稱",
		emailPla: "請輸入您的郵箱",
		VCodePla: "請輸入驗證碼",
		VCodeBtn: "獲取驗證碼",
		PwdPla: "請輸入密碼",
		SubmitBtn: "同意協定並註冊",
		RidaoBtn: "我同意",
		PwdPlaErr: "兩次输入的密码不相同",
		Agreement: "《經藝平台服務協定》",
		Radio: "請勾選經藝平台服務協定",
		Success: "驗證碼傳送成功",
		Countries: "選擇區號",
		smsCode: "請選擇區號",
		videoTitle: "經藝聯介紹",
		videoTitle2: "當代藝術市場的機遇",
		videoTitle3: "什麼是藝術",
		hot: "熱門地區",
		all: "所有地區",
		videoText: "經藝聯是一個藝術品線上交易平台",
		downLoad: '下載APP安裝'
	}
}
